/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListRequest =
  {
    organizationId?: string | undefined;
    tenantId?: string | undefined;
    pageSize?: number | undefined;
    pageNumber?: number | undefined;
    status?: string | undefined;
  };

export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListStatus =
  {
    StatusUnspecified: "STATUS_UNSPECIFIED",
    StatusActive: "STATUS_ACTIVE",
    StatusSuspended: "STATUS_SUSPENDED",
    StatusPendingVerification: "STATUS_PENDING_VERIFICATION",
    StatusRevoked: "STATUS_REVOKED",
    StatusExpired: "STATUS_EXPIRED",
    StatusRateLimited: "STATUS_RATE_LIMITED",
    StatusPendingReview: "STATUS_PENDING_REVIEW",
    StatusDeprecated: "STATUS_DEPRECATED",
    StatusMaintenance: "STATUS_MAINTENANCE",
  } as const;
export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListStatus =
  ClosedEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListStatus
  >;

export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListScopes =
  {
    TenantApiKeyScopeUnspecified: "TENANT_API_KEY_SCOPE_UNSPECIFIED",
    TenantApiKeyScopeReadJobs: "TENANT_API_KEY_SCOPE_READ_JOBS",
    TenantApiKeyScopeReadLeads: "TENANT_API_KEY_SCOPE_READ_LEADS",
    TenantApiKeyScopeReadWorkflows: "TENANT_API_KEY_SCOPE_READ_WORKFLOWS",
    TenantApiKeyScopeReadAnalytics: "TENANT_API_KEY_SCOPE_READ_ANALYTICS",
    TenantApiKeyScopeReadSettings: "TENANT_API_KEY_SCOPE_READ_SETTINGS",
    TenantApiKeyScopeWriteJobs: "TENANT_API_KEY_SCOPE_WRITE_JOBS",
    TenantApiKeyScopeWriteLeads: "TENANT_API_KEY_SCOPE_WRITE_LEADS",
    TenantApiKeyScopeWriteWorkflows: "TENANT_API_KEY_SCOPE_WRITE_WORKFLOWS",
    TenantApiKeyScopeWriteSettings: "TENANT_API_KEY_SCOPE_WRITE_SETTINGS",
    TenantApiKeyScopeDeleteJobs: "TENANT_API_KEY_SCOPE_DELETE_JOBS",
    TenantApiKeyScopeDeleteLeads: "TENANT_API_KEY_SCOPE_DELETE_LEADS",
    TenantApiKeyScopeDeleteWorkflows: "TENANT_API_KEY_SCOPE_DELETE_WORKFLOWS",
    TenantApiKeyScopeExportData: "TENANT_API_KEY_SCOPE_EXPORT_DATA",
    TenantApiKeyScopeManageKeys: "TENANT_API_KEY_SCOPE_MANAGE_KEYS",
    TenantApiKeyScopeBillingRead: "TENANT_API_KEY_SCOPE_BILLING_READ",
    TenantApiKeyScopeBillingWrite: "TENANT_API_KEY_SCOPE_BILLING_WRITE",
    TenantApiKeyScopeAdmin: "TENANT_API_KEY_SCOPE_ADMIN",
  } as const;
export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListScopes =
  ClosedEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListScopes
  >;

export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListApiKeys =
  {
    id?: string | undefined;
    keyHash?: string | undefined;
    keyPrefix?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    status?:
      | GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListStatus
      | undefined;
    scopes?:
      | Array<
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListScopes
      >
      | undefined;
    maxUses?: number | undefined;
    allowedIps?: Array<string> | undefined;
    useCount?: number | undefined;
    expiresAt?: Date | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
  };

export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListData =
  {
    apiKeys?:
      | Array<
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListApiKeys
      >
      | undefined;
    nextPageNumber?: number | undefined;
    totalCount?: number | undefined;
  };

/**
 * Retrieves all API keys for a specific tenant
 */
export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListResponseBody =
  {
    data: GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListData;
  };

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListRequest$inboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    organizationId: z.string().optional(),
    tenantId: z.string().optional(),
    pageSize: z.number().optional(),
    pageNumber: z.number().optional(),
    status: z.string().optional(),
  });

/** @internal */
export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListRequest$Outbound =
  {
    organizationId?: string | undefined;
    tenantId?: string | undefined;
    pageSize?: number | undefined;
    pageNumber?: number | undefined;
    status?: string | undefined;
  };

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListRequest$outboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListRequest$Outbound,
    z.ZodTypeDef,
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListRequest
  > = z.object({
    organizationId: z.string().optional(),
    tenantId: z.string().optional(),
    pageSize: z.number().optional(),
    pageNumber: z.number().optional(),
    status: z.string().optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListRequest$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListRequest$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListRequest$outboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListRequest$Outbound` instead. */
  export type Outbound =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListRequest$Outbound;
}

export function getApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListRequestToJSON(
  getApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListRequest:
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListRequest,
): string {
  return JSON.stringify(
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListRequest$outboundSchema
      .parse(
        getApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListRequest,
      ),
  );
}

export function getApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListRequest$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListRequest' from JSON`,
  );
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListStatus$inboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListStatus
  > = z.nativeEnum(
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListStatus,
  );

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListStatus$outboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListStatus
  > =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListStatus$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListStatus$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListStatus$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListStatus$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListStatus$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListStatus$outboundSchema;
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListScopes$inboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListScopes
  > = z.nativeEnum(
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListScopes,
  );

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListScopes$outboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListScopes
  > =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListScopes$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListScopes$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListScopes$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListScopes$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListScopes$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListScopes$outboundSchema;
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListApiKeys$inboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListApiKeys,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    keyHash: z.string().optional(),
    keyPrefix: z.string().optional(),
    name: z.string().optional(),
    description: z.string().optional(),
    status:
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListStatus$inboundSchema
        .default("STATUS_UNSPECIFIED"),
    scopes: z.array(
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListScopes$inboundSchema,
    ).optional(),
    maxUses: z.number().int().optional(),
    allowedIps: z.array(z.string()).optional(),
    useCount: z.number().int().optional(),
    expiresAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
  });

/** @internal */
export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListApiKeys$Outbound =
  {
    id?: string | undefined;
    keyHash?: string | undefined;
    keyPrefix?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    status: string;
    scopes?: Array<string> | undefined;
    maxUses?: number | undefined;
    allowedIps?: Array<string> | undefined;
    useCount?: number | undefined;
    expiresAt?: string | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
  };

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListApiKeys$outboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListApiKeys$Outbound,
    z.ZodTypeDef,
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListApiKeys
  > = z.object({
    id: z.string().optional(),
    keyHash: z.string().optional(),
    keyPrefix: z.string().optional(),
    name: z.string().optional(),
    description: z.string().optional(),
    status:
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListStatus$outboundSchema
        .default("STATUS_UNSPECIFIED"),
    scopes: z.array(
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListScopes$outboundSchema,
    ).optional(),
    maxUses: z.number().int().optional(),
    allowedIps: z.array(z.string()).optional(),
    useCount: z.number().int().optional(),
    expiresAt: z.date().transform(v => v.toISOString()).optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListApiKeys$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListApiKeys$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListApiKeys$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListApiKeys$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListApiKeys$outboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListApiKeys$Outbound` instead. */
  export type Outbound =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListApiKeys$Outbound;
}

export function getApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListApiKeysToJSON(
  getApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListApiKeys:
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListApiKeys,
): string {
  return JSON.stringify(
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListApiKeys$outboundSchema
      .parse(
        getApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListApiKeys,
      ),
  );
}

export function getApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListApiKeysFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListApiKeys,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListApiKeys$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListApiKeys' from JSON`,
  );
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListData$inboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListData,
    z.ZodTypeDef,
    unknown
  > = z.object({
    apiKeys: z.array(
      z.lazy(() =>
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListApiKeys$inboundSchema
      ),
    ).optional(),
    nextPageNumber: z.number().int().optional(),
    totalCount: z.number().int().optional(),
  });

/** @internal */
export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListData$Outbound =
  {
    apiKeys?:
      | Array<
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListApiKeys$Outbound
      >
      | undefined;
    nextPageNumber?: number | undefined;
    totalCount?: number | undefined;
  };

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListData$outboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListData$Outbound,
    z.ZodTypeDef,
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListData
  > = z.object({
    apiKeys: z.array(
      z.lazy(() =>
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListApiKeys$outboundSchema
      ),
    ).optional(),
    nextPageNumber: z.number().int().optional(),
    totalCount: z.number().int().optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListData$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListData$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListData$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListData$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListData$outboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListData$Outbound` instead. */
  export type Outbound =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListData$Outbound;
}

export function getApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListDataToJSON(
  getApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListData:
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListData,
): string {
  return JSON.stringify(
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListData$outboundSchema
      .parse(
        getApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListData,
      ),
  );
}

export function getApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListDataFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListData,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListData$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListData' from JSON`,
  );
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListResponseBody$inboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    data: z.lazy(() =>
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListData$inboundSchema
    ),
  });

/** @internal */
export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListResponseBody$Outbound =
  {
    data:
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListData$Outbound;
  };

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListResponseBody$outboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListResponseBody$Outbound,
    z.ZodTypeDef,
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListResponseBody
  > = z.object({
    data: z.lazy(() =>
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListData$outboundSchema
    ),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListResponseBody$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListResponseBody$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListResponseBody$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListResponseBody$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListResponseBody$outboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListResponseBody$Outbound` instead. */
  export type Outbound =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListResponseBody$Outbound;
}

export function getApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListResponseBodyToJSON(
  getApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListResponseBody:
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListResponseBody,
): string {
  return JSON.stringify(
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListResponseBody$outboundSchema
      .parse(
        getApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListResponseBody,
      ),
  );
}

export function getApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListResponseBody,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListResponseBody$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysListResponseBody' from JSON`,
  );
}
